// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
 apiKey: "AIzaSyDpGSBjhGXqGtR5aNnE9hfIQNubYRi4Zis",
  authDomain: "ghana-bundle.firebaseapp.com",
  projectId: "ghana-bundle",
  storageBucket: "ghana-bundle.firebasestorage.app",
  messagingSenderId: "808485376098",
  appId: "1:808485376098:web:6a12ba419c5d0bbcda413b",
  measurementId: "G-1VQ04VWNBL"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
